import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      notConvincedBanner: {
        livejasmin: {
          ...defineMessages({
            notConvincedYet: {
              id: 'pages.landing.notConvincedBanner.livejasmin.notConvincedYet',
              defaultMessage: 'Not <b>convinced yet?</b>',
            },
            largestNetworks: {
              id: 'pages.landing.notConvincedBanner.livejasmin.largestNetworks',
              defaultMessage:
                'We’re part of one of the largest networks in the industry, including other types of cam streaming, fan sites or tube sites, so you’re sure to find what suits you best.',
            },
            explore: {
              id: 'pages.landing.notConvincedBanner.livejasmin.explore',
              defaultMessage: 'Explore some of our other platforms to discover your ideal fit!',
            },
            visitSite: {
              id: 'pages.landing.notConvincedBanner.livejasmin.visitSite',
              defaultMessage: 'Visit site',
            },
            fanClubPlatorm: {
              id: 'pages.landing.notConvincedBanner.livejasmin.fanClubPlatorm',
              defaultMessage:
                'An all-inclusive fan-club platform that enables artists and creators of all types to turn their unique efforts and perspective into thriving and interactive businesses online.',
            },
            adultContentPlatform: {
              id: 'pages.landing.notConvincedBanner.livejasmin.adultContentPlatform',
              defaultMessage:
                'An adult content platform that enables creators and production companies to upload videos for different niches and engage with millions of visitors worldwide.',
            },
            streamingPlatform: {
              id: 'pages.landing.notConvincedBanner.livejasmin.streamingPlatform',
              defaultMessage:
                'A streaming platform for adults that combines gaming and social media elements to provide performers with an innovative, fun, and engaging way to cam and make money.',
            },
            discoveryPlatform: {
              id: 'pages.landing.notConvincedBanner.livejasmin.discoveryPlatform',
              defaultMessage:
                'The first discovery platform for creators, reaching {visitors} million visitors per day.',
            },
          }),
        },
      },
    },
  },
};
